// extracted by mini-css-extract-plugin
module.exports = {"option":"CategoriesDropdown_option__OH8ui","appearance":"CategoriesDropdown_appearance__jVFw5","disappearance":"CategoriesDropdown_disappearance__pxPte"};